import React from 'react';

export const SingleTable = props => {
	return (
		<div className='singleTable-container' onClick={() => props.onSelectANI(props.data)}>
			<div className='singleTable-li'>{props.data}</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/SingleTable.jsx